import ReactPaginate from "react-paginate";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";
import Item from 'components/Direccion/Item';
import { ITEMS_BY_PAGE_OPTIONS } from "constants/pagination";

function Table({ 
        setSelectedDireccion, 
        getVinculedClients, 
        setModalVincularCliente, 
        direcciones = [], 
        getDirecciones, 
        deleteDireccion, 
        totalPages, 
        setPage, 
        page, 
        isSearched, 
        setIsSearched, 
        setSelectedDirection,
        itemsPerPage,
        setItemsPerPage,
        hasSearched,
        resetSearch,
        totalDirecciones,
    }) {
    let myAbilities = HelpAbility();
    const { search, option, state } = isSearched;

    const handlePageClick = (data) => {
        state ? getDirecciones({ page: data.selected + 1, [option]: search }) : getDirecciones({ page: data.selected + 1 });
    };

    const resetDirecciones = async () => {
        setIsSearched({
            search: '',
            option: '',
            state: false
        })
        setPage(1);
        getDirecciones({});
        resetSearch();
    };

    const onItemsPerPageChange = (e) => {
        const newItemsPerPage = e.target.value;
        setItemsPerPage(newItemsPerPage);
        state ? getDirecciones({page: 1, limit: newItemsPerPage, [option]: search}) : getDirecciones({page: 1, limit: newItemsPerPage});
    }
    return (
        <>
        

        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Direcciones registrados</h6>
                </div>
                <div className="col d-flex justify-content-end"> 
                    <div className="d-flex flex-row gap-3">
                    <div className="col d-flex flex-row align-items-center gap-2">
                        <label htmlFor="items-by-page" className="form-label mb-0">Mostrar: </label>
                        <select 
                            onChange={onItemsPerPageChange} 
                            className="form-select form-select-sm" 
                            aria-label="Default select example" 
                            name="items-by-page" 
                            style={{width: '70px'}} 
                            value={itemsPerPage}
                        >
                        {
                            ITEMS_BY_PAGE_OPTIONS.map((value, index, arr) => {
                                if(totalDirecciones <= arr?.[index - 1]) return null;
                                return (
                                    <option 
                                        value={value} 
                                        key={'item-by-page-option-' + value}
                                    >
                                        {value}
                                    </option>
                                )
                            })
                        }            
                        </select>
                    </div>
                    <button type="submit" className="btn btn-primary" onClick={resetDirecciones} disabled={!hasSearched}>Limpiar búsqueda</button>
                    </div>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{ border: '1px solid black' }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col" className="text-center">#</th>
                            <th scope="col" className="text-center">Alias</th>
                            <th scope="col" className="text-center">Barrio</th>
                            <th scope="col" className="text-center">Cod Ciudad</th>
                            <th scope="col" className="text-center">Cod Departamento</th>
                            <th scope="col" className="text-center">Direccion</th>
                            <th scope="col" className="text-center">Dirección ID</th>
                            <th scope="col" className="text-center">Dirección Predeterminada</th>
                            <th scope="col" className="text-center">Cliente Asociado</th>
                            {myAbilities.hasAny([C.A.DIRECTION.LINK, C.A.DIRECTION.UPDATE, C.A.DIRECTION.DELETE]) &&
                                <th scope="col" className="text-center">Acción</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            direcciones.length ?
                                direcciones.map((direccion, i) => <Item
                                    key={direccion._id}
                                    i={i}
                                    direccion={direccion}
                                    deleteDireccion={deleteDireccion}
                                    setModalVincularCliente={setModalVincularCliente}
                                    setSelectedDirection={setSelectedDirection}
                                    getVinculedClients={getVinculedClients}
                                    setSelectedDireccion={setSelectedDireccion}
                                />)
                                :
                                <tr>
                                    <td colSpan="5">Sin datos</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div>
                <ReactPaginate
                    previousLabel={"Anterior"}
                    nextLabel={"Siguiente"}
                    breakLabel={"..."}
                    pageCount={totalPages}
                    //Cuantas paginas quieres mostrar despues de los 3 ...
                    marginPagesDisplayed={1}
                    //En cada pagina tiene dos lados, uno izquierda y otro derecha, cuantas n paginas quieres en eso dos lados, excepto para la primera y ultima pagina que para estos cubriran n paginas pero para su dirección de ida o retorno de lado respectivamente
                    pageRangeDisplayed={2}
                    forcePage={page - 1}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center mt-3"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                />
            </div>
        </div>

        </>
      
    )
}

export default Table
